// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "0.0.14/static/js/" + chunkId + "." + "663fa7a6" + ".chunk.js";
};